import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-success-response',
  templateUrl: './success-response.component.html',
  styleUrls: ['./success-response.component.css']
})
export class SuccessResponseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
